const fetchWithTimeout = (request, timeout = 30000) => {
    return Promise.race([
        fetch(request),
        new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), timeout)),
    ]);
};
export default fetchWithTimeout;
//# sourceMappingURL=fetchWithTimeout.js.map